import React, { useState, useContext } from 'react'
import { useMutation } from '@apollo/client'
import Router from 'next/router'
import { MailOutlined, LockFilled } from '@ant-design/icons'
import { Row, Form, Input, message } from 'antd'
import Button from 'components/shared/button'
import authToken from 'contexts/authToken'
import {
  Login_MutationDocument,
  Update_UserDocument,
} from 'graphql/generated/types'
import PropTypes from 'prop-types'
import { addSuccess } from 'redux-flash-messages'

const FormItem = Form.Item

const validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: '${label} is required!',
  types: {
    // eslint-disable-next-line no-template-curly-in-string
    email: '${label} is not valid!',
  },
}

export default function EmailLogin({ callbackbeforeRedirect }) {
  const [userEmail, setuserEmail] = useState('')
  const [userPassword, setuserPassword] = useState('')
  const [Login, { data }] = useMutation(Login_MutationDocument)
  if (data) {
    if (callbackbeforeRedirect) {
      callbackbeforeRedirect()
    } else {
      addSuccess({ text: 'Registration Successfull' })
      Router.push('/')
    }
  }
  const token: any = useContext(authToken)
  const { setToken } = token
  const [updateUser] = useMutation(Update_UserDocument)
  const formItemLayout = { wrapperCol: { span: 32 } }
  return (
    <Row>
      <Form
        name="basic"
        layout="vertical"
        {...formItemLayout}
        className="login-form"
        onFinish={() => {
          Login({
            variables: {
              input: {
                identifier: userEmail,
                password: userPassword,
              },
            },
          })
            .then((res) => {
              localStorage.setItem('authToken', res.data.login.jwt)
              localStorage.setItem('userEmail', res.data.login.user.email)
              localStorage.setItem('userId', res.data.login.user.id)
              setToken(res.data.login.jwt)
              updateUser({
                context: {
                  headers: {
                    Authorization: `Bearer ${res.data.login.jwt}`,
                  },
                },
              }).catch((err) => {
                message.error('---update err----', err)
              })
            })
            .catch((error) => {
              if (error.message === 'GraphQL error: Bad Request') {
                message.error('Invalid Email or Password')
              } else {
                message.error('Sorry Something Went Wrong!')
              }
            })
        }}
        validateMessages={validateMessages}
      >
        <FormItem
          {...formItemLayout}
          label="Email Address"
          name="email"
          rules={[{ required: true, type: 'email' }]}
        >
          <Input
            addonBefore={<MailOutlined />}
            placeholder="john.doe@gmail.com"
            autoComplete="off"
            autoFocus
            onChange={(e) => {
              setuserEmail(e.target.value)
            }}
          />
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="password"
          label="Password"
          rules={[{ required: true, message: 'Please input your Password!' }]}
        >
          <Input.Password
            addonBefore={<LockFilled />}
            placeholder="Password"
            onChange={(e) => {
              setuserPassword(e.target.value)
            }}
          />
        </FormItem>

        <FormItem className="m-b-0" {...formItemLayout}>
          <Button
            type="primary"
            size="middle"
            icon={<LockFilled />}
            className="auth--button--login"
            htmlType="submit"
            source="email-login"
          >
            Login Now
          </Button>
        </FormItem>
      </Form>
    </Row>
  )
}

EmailLogin.propTypes = {
  callbackbeforeRedirect: PropTypes.func,
}
